import { render, staticRenderFns } from "./editSubscribe.vue?vue&type=template&id=a5dc8148&scoped=true&"
import script from "./editSubscribe.vue?vue&type=script&lang=js&"
export * from "./editSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./editSubscribe.vue?vue&type=style&index=0&id=a5dc8148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dc8148",
  null
  
)

export default component.exports